export const STATUSES = {
  PENDING: 'PENDING',
  RESOLVED: 'RESOLVED',
};
